import {
  all,
  call,
  fork,
  put,
  select,
  cancelled,
  takeEvery,
  takeLatest,
} from "@redux-saga/core/effects";
import {
  ADD_WHITE_LIST,
  ADMIN_GET_MISSION_BY_ID,
  ADMIN_REPORT,
  CHANGE_ACCOUNT_STATUS,
  CHANGE_ADDRESS,
  CHANGE_ETC_MISSING_STATUS,
  CHANGE_MISSING_STATUS,
  CHANGE_ROLE,
  CHANGE_ROLE_SUCCESS,
  DELETE_EVENT,
  GET_ADMIN_FOUND,
  GET_ADMIN_MISSING,
  GET_ETC_MISSING,
  GET_LOG,
  GET_SETTING,
  GET_USER,
  GET_WHITE_LIST,
  ON_UPDATE_Missing,
  REMOVE_WHITE_LIST,
  RESET_PASSWORD,
  UPDATE_SETTING,
} from "../../constants/ActionTypes";
import { deleteData, getData, postData,putData } from "../../util/DynamicApi";
import { ShowSmallError, ShowSuccess } from "../../util/MessageHelper";
import {
  UpdateMissionSuccess,
  addWhiteListSuccess,
  changeAccountStatusSuccess,
  changeAddressSuccess,
  changeEtcMissingStatusSuccess,
  changeMissingStatusSuccess,
  changeRoleSuccess,
  deleteEventSucess,
  getEtcMissingSuccess,
  getFoundSuccess,
  getLogSuccess,
  getMissingSuccess,
  getMissionById,
  getMissionByIdSuccess,
  getSettingSuccess,
  getUserSuccess,
  getWhiteListSuccess,
  hideAdminLoader,
  removeWhiteListSuccess,
  reportSucess,
  resetPasswordSuccess,
  updateSettingSuccess,
} from "../actions/Admin";

export const getToken = ({ auth }) => auth.token;

const getUserRequest = async (token, data) =>
  await getData(token, "admin/users/list", data)
    .then((users) => {
      if(users.errorMessage){
        return users;
      }
      return users.data;
    })
    .catch((error) => {
      //return error.response.data;
      return error.response.data;
    });

const addWhiteListRequest = async (token, data) =>
  await postData(token, "admin/white-price-lists", data.payload)
    .then((result) => {
      if(result.errorMessage){
        return result;
      }
      return result.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const removeWhiteListRequest = async (token, data) =>
  await deleteData(token, `admin/${data.payload.WhiteListId}`, data.payload)
    .then((result) => {
      if(result.errorMessage){
        return result;
      }
      return result;
    })
    .catch((error) => {
      return error.response.data;
    });

const getWhiteListRequest = async (token, data) =>
  await getData(token, "setting/white-list-prices", data)
    .then((whiteList) => {
      if(whiteList.errorMessage){
        return whiteList;
      }
      return whiteList.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const getLogRequest = async (token, data) =>
  await getData(token, "Support/GetLog", data)
    .then((logs) => {
      return logs;
    })
    .catch((error) => {
      return error.response.data;
    });
const getMissingRequest = async (token, data) =>
  await getData(token, "admin/missing", data)
    .then((missing) => {
      if(missing.errorMessage){
        return missing;
      }
      return missing.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const getEtcMissingRequest = async (token, data) =>
  await getData(token, "Admin/GetEtcAdvertisingList", data)
    .then((etcMissing) => {
      return etcMissing;
    })
    .catch((error) => {
      return error.response.data;
    });

const getFoundRequest = async (token, data) =>
  await getData(token, "Admin/GetFoundList", data)
    .then((found) => {
      return found;
    })
    .catch((error) => {
      return error.response.data;
    });

const getSettingRequest = async (token) =>
  await getData(token, "setting", null)
    .then((users) => {
      if(users.errorMessage){
        return users;
      }
      return users.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const updateMissingRequest = async (token, data) =>
  await postData(token, "Admin/UpdateMissing", data.payload)
    .then((missing) => {
      return missing;
    })
    .catch((error) => {
      return error.response.data;
    });

const getAdminReport = async (token, startDateTime, endDateTime) =>
  await getData(token, "admin/statistics", {
    startDateTime: startDateTime,
    endDateTime: endDateTime,
  })
    .then((data) => {
      if(data.errorMessage){
        return data;
      }
      return data.data;
    })
    .catch((error) => {
      return {
        errorMessage:
          error?.response?.data?.errors?.[0]?.message ||
          error?.message ||
          "در انجام عملیات خطایی به وجود آمد",
      };
    });

const callGetMissionById = async (token, missionId) =>
  await getData(token, `admin/missions/${missionId}`, {
    missionId: missionId,
  })
    .then((data) => {
      if(data.errorMessage){
        return data;
      }
      return data.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const updateSettingRequest = async (token, data) =>
  await putData(token, "setting", data.payload)
    .then((updateSetting) => {
      if(updateSetting.errorMessage){
        return updateSetting;
      }
      return updateSetting.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const changeAccountStatusRequest = async (token, data) =>
  await putData(token, "admin/users/status", data.payload)
    .then((changeAccountStatus) => {
      if(changeAccountStatus.errorMessage){
        return changeAccountStatus;
      }
      return changeAccountStatus.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const changeRoleStatusRequest = async (token, data) =>
  await putData(token, "admin/users/roles", data.payload)
    .then((changeRole) => {
      if(changeRole.errorMessage){
        return changeRole;
      }
      return changeRole.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const changeMissingStatusRequest = async (token, data) =>
  await putData(token, "admin/missing/status", data.payload)
    .then((changeMissingSatus) => {
      if(changeMissingSatus.errorMessage){
        return changeMissingSatus;
      }
      return changeMissingSatus.data;
    })
    .catch((error) => {
      return error.response.data;
    });

const changeEtcMissingStatusRequest = async (token, data) =>
  await postData(token, "Admin/ChangeEtcAdvertisingStatus", data.payload)
    .then((changeEtcMissingStatus) => {
      return changeEtcMissingStatus;
    })
    .catch((error) => {
      return error.response.data;
    });

const deleteEventRequest = async (token, data) =>
  await postData(token, "Admin/DeleteEvent", data.payload)
    .then((status) => {
      return status;
    })
    .catch((error) => {
      return error.response.data;
    });

const resetPasswordRequest = async (token, data) =>
  await postData(token, "Admin/ResetPassword", data.payload)
    .then((status) => {
      return status;
    })
    .catch((error) => {
      return error.response.data;
    });

const changeAddressRequest = async (token, data) =>
  await putData(token, `admin/users/${data.payload.userManagementId}/address`, data.payload)
    .then((status) => {
      if(status.errorMessage){
        return status;
      }
      return status.data;
    })
    .catch((error) => {
      return error.response.data;
    });
function* doAddWhiteList(payload) {
  try {
    let token = yield select(getToken);
    const addWhiteList = yield call(addWhiteListRequest, token, payload);
    if (addWhiteList.errorMessage) {
      ShowSmallError(addWhiteList.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(addWhiteListSuccess());
      ShowSuccess("افزودن به لیست ویژه");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doRemoveWhiteList(payload) {
  try {
    let token = yield select(getToken);
    const removeWhiteList = yield call(removeWhiteListRequest, token, payload);
    if (removeWhiteList.errorMessage) {
      ShowSmallError(removeWhiteList.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(removeWhiteListSuccess());
      ShowSuccess("حذف از لیست ویژه");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doGetWhiteList(payload) {
  try {
    var data = { payload };
    let token = yield select(getToken);
    const whiteList = yield call(
      getWhiteListRequest,
      token,
      data.payload.payload
    );
    if (whiteList.errorMessage) {
      ShowSmallError(whiteList.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getWhiteListSuccess(whiteList.data));
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doGetUser(payload) {
  try {
    var data = { payload };
    let token = yield select(getToken);
    const users = yield call(getUserRequest, token, data.payload.payload);
    if (users.errorMessage) {
      ShowSmallError(users.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getUserSuccess(users.data, data.payload.payload.forceReresh));
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doGetLog(payload) {
  try {
    var data = { payload };
    let token = yield select(getToken);
    const log = yield call(getLogRequest, token, data.payload.payload);
    if (log.errorMessage) {
      ShowSmallError(log.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getLogSuccess(log.data));
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doGetMissing(payload) {
  try {
    let token = yield select(getToken);
    var data = { payload };
    //console.log(data);
    const getMissing = yield call(
      getMissingRequest,
      token,
      data.payload.payload
    );
    
    if (getMissing.errorMessage) {
      ShowSmallError(getMissing.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getMissingSuccess(getMissing.data));
    }
  } catch (error) {
    if (!(yield cancelled())) {
      console.info(error);
      ShowSmallError(error);
      yield put(hideAdminLoader());
    }
  } finally {
    if (yield cancelled()) {
      yield put(hideAdminLoader());
    }
  }
}
function* doGetEtcMissing(payload) {
  try {
    let token = yield select(getToken);
    var data = { payload };
    const etcMissing = yield call(
      getEtcMissingRequest,
      token,
      data.payload.payload
    );
    if (etcMissing.errorMessage) {
      ShowSmallError(etcMissing.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getEtcMissingSuccess(etcMissing.data));
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doGetFound(payload) {
  try {
    let token = yield select(getToken);
    var data = { payload };
    const found = yield call(getFoundRequest, token, data.payload.payload);
    if (found.errorMessage) {
      ShowSmallError(found.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getFoundSuccess(found.data));
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doGetSetting() {
  try {
    let token = yield select(getToken);
    const setting = yield call(getSettingRequest, token);
    if (setting.errorMessage) {
      ShowSmallError(setting.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getSettingSuccess(setting.data));
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doUpdateSetting(payload) {
  try {
    let token = yield select(getToken);
    const updateSetting = yield call(updateSettingRequest, token, payload);
    if (updateSetting.errorMessage) {
      ShowSmallError(updateSetting.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(updateSettingSuccess(payload));
      ShowSuccess("ویرایش تنظیمات");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doChangeAccountStatus(payload) {
  try {
    let token = yield select(getToken);
    const changeAccountStatus = yield call(
      changeAccountStatusRequest,
      token,
      payload
    );

    if (changeAccountStatus.errorMessage) {
      ShowSmallError(changeAccountStatus.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(changeAccountStatusSuccess());
      ShowSuccess("تغییر وضعیت حساب");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doChangeRole(payload) {
  try {
    let token = yield select(getToken);
    const changeRole = yield call(changeRoleStatusRequest, token, payload);
    if (changeRole.errorMessage) {
      ShowSmallError(changeRole.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(changeRoleSuccess());
      ShowSuccess("تغییر وضعیت حساب");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doChangeMissingStatus(payload) {
  try {
    let token = yield select(getToken);
    const changeMissingStatus = yield call(
      changeMissingStatusRequest,
      token,
      payload
    );
    if (changeMissingStatus.errorMessage) {
      ShowSmallError(changeMissingStatus.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(changeMissingStatusSuccess());
      ShowSuccess("تغییر وضعیت حساب");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doChangeEtcMissingStatus(payload) {
  try {
    let token = yield select(getToken);
    const changeEtcMissingStatus = yield call(
      changeEtcMissingStatusRequest,
      token,
      payload
    );
    if (changeEtcMissingStatus.errorMessage) {
      ShowSmallError(changeEtcMissingStatus.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(changeEtcMissingStatusSuccess());
      ShowSuccess("تغییر وضعیت حساب");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doDeleteEvent(payload) {
  try {
    let token = yield select(getToken);
    const deleteEventStatus = yield call(deleteEventRequest, token, payload);
    if (deleteEventStatus.errorMessage) {
      ShowSmallError(deleteEventStatus.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(deleteEventSucess());
      ShowSuccess("عملیات با موفقیت انجام شد");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}

function* doResetPassword(payload) {
  try {
    let token = yield select(getToken);
    const resetPasswordStatus = yield call(
      resetPasswordRequest,
      token,
      payload
    );
    if (resetPasswordStatus.errorMessage) {
      ShowSmallError(resetPasswordStatus.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(resetPasswordSuccess());
      ShowSuccess("عملیات با موفقیت انجام شد");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doChangeAddress(payload) {
  try {
    let token = yield select(getToken);
    const changeAddressStatus = yield call(
      changeAddressRequest,
      token,
      payload
    );
    if (changeAddressStatus.errorMessage) {
      ShowSmallError(changeAddressStatus.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(changeAddressSuccess());
      ShowSuccess("عملیات با موفقیت انجام شد");
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
function* doAdminReport({ payload }) {
  try {
    let token = yield select(getToken);
    const adminReport = yield call(
      getAdminReport,
      token,
      payload.startDateTime,
      payload.endDateTime
    );
    if (adminReport?.errorMessage) {
      ShowSmallError(adminReport.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(reportSucess(adminReport.data));
    }
  } catch (error) {
    if (!(yield cancelled())) {
      ShowSmallError(error);
      yield put(hideAdminLoader());
    }
  } finally {
    if (yield cancelled()) {
      yield put(hideAdminLoader());
    }
  }
}

function* doUpdateMissing(payload) {
  try {
    let token = yield select(getToken);
    const missing = yield call(updateMissingRequest, token, payload);

    if (missing.errorMessage) {
      ShowSmallError(missing.errorMessage);
      yield put(hideAdminLoader());
    } else {
      ShowSuccess("عملیات با موفقیت انجام شد");
      yield put(UpdateMissionSuccess());
    }
  } catch (error) {
    yield put(ShowSmallError(error));
  }
}

function* doAdminGetMission({ payload }) {
  try {
    let token = yield select(getToken);
    const adminGetMission = yield call(
      callGetMissionById,
      token,
      payload.missionId
    );
    if (adminGetMission.errorMessage) {
      ShowSmallError(adminGetMission.errorMessage);
      yield put(hideAdminLoader());
    } else {
      yield put(getMissionByIdSuccess(adminGetMission.data));
    }
  } catch (error) {
    yield ShowSmallError(error);
  }
}
export function* addWhiteList() {
  yield takeEvery(ADD_WHITE_LIST, doAddWhiteList);
}
export function* removeWhiteList() {
  yield takeEvery(REMOVE_WHITE_LIST, doRemoveWhiteList);
}
export function* getWhiteList() {
  yield takeEvery(GET_WHITE_LIST, doGetWhiteList);
}
export function* getUser() {
  yield takeEvery(GET_USER, doGetUser);
}
export function* getLog() {
  yield takeEvery(GET_LOG, doGetLog);
}
export function* getMissing() {
  yield takeLatest(GET_ADMIN_MISSING, doGetMissing);
}
export function* getEtcMissing() {
  yield takeEvery(GET_ETC_MISSING, doGetEtcMissing);
}
export function* getFound() {
  yield takeEvery(GET_ADMIN_FOUND, doGetFound);
}
export function* getSetting() {
  yield takeEvery(GET_SETTING, doGetSetting);
}
export function* updateSetting() {
  yield takeEvery(UPDATE_SETTING, doUpdateSetting);
}
export function* changeAccountStatus() {
  yield takeEvery(CHANGE_ACCOUNT_STATUS, doChangeAccountStatus);
}
export function* changeRole() {
  yield takeEvery(CHANGE_ROLE, doChangeRole);
}
export function* changeMissingStatus() {
  yield takeEvery(CHANGE_MISSING_STATUS, doChangeMissingStatus);
}
export function* changeEtcMissingStatus() {
  yield takeEvery(CHANGE_ETC_MISSING_STATUS, doChangeEtcMissingStatus);
}
export function* deleteEvent() {
  yield takeEvery(DELETE_EVENT, doDeleteEvent);
}

export function* resetPassword() {
  yield takeEvery(RESET_PASSWORD, doResetPassword);
}
export function* changeAddress() {
  yield takeEvery(CHANGE_ADDRESS, doChangeAddress);
}
export function* getAdminReportFire() {
  yield takeLatest(ADMIN_REPORT, doAdminReport);
}
export function* fireGetMissionById() {
  yield takeEvery(ADMIN_GET_MISSION_BY_ID, doAdminGetMission);
}
export function* fireUpdateMission() {
  yield takeEvery(ON_UPDATE_Missing, doUpdateMissing);
}
export default function* rootSaga() {
  yield all([
    fork(getUser),
    fork(getMissing),
    fork(getEtcMissing),
    fork(getFound),
    fork(getSetting),
    fork(updateSetting),
    fork(changeAccountStatus),
    fork(changeRole),
    fork(changeMissingStatus),
    fork(changeEtcMissingStatus),
    fork(getLog),
    fork(addWhiteList),
    fork(removeWhiteList),
    fork(getWhiteList),
    fork(deleteEvent),
    fork(resetPassword),
    fork(changeAddress),
    fork(getAdminReportFire),
    fork(fireGetMissionById),
    fork(fireUpdateMission),
  ]);
}
